/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React, {useState} from "react";
import {ContextNodeLink} from "../../../Components/Common/ContextNodeViewer";
import {ConfirmationDialog} from "../../../Components/Common/ConfirmationDialog";


export const ContextNodesFieldViewer = (props) => {
	const {Value} = props;
	const contextNodeIds = Value ? Value.split(", ") : [];

	const [showModal, setShowModal] = useState(false);

	const limitedContextNodeIds = contextNodeIds.splice(0, 5);

	return <div className="sb-context-nodes-viewer">
		<ConfirmationDialog
			Title={"Projects"}
			Body={contextNodeIds.map((contextNodeId, i) => (
				<div key={contextNodeId}>
					<ContextNodeLink contextNodeId={contextNodeId} />
				</div>
			))}
			ConfirmationButtonMessage="Close"
			Display={showModal}
			OnConfirm={() => setShowModal(false)}
		/>
		<div className="ellipsis-container">
			<div className="ellipsis">
				{
					limitedContextNodeIds.map((contextNodeId, i) => {
						return <span key={contextNodeId}>
							<ContextNodeLink contextNodeId={contextNodeId} />{i < contextNodeIds.length - 1 && ', '}
						</span>
					})
				}
			</div>
		</div>
		<a className="btn btn-link" onClick={() => setShowModal(true)}>more</a>
	</div>
}

